import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I have</h5>
      <h2>My Experience</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>FrontEnd Developer</h3>

          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>HTML</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>CSS</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>JS</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>ReactJs</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Bootstrap</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
          </div>
        </div>
{/* ======= End of FrontEnd ======= */}

        <div className="experience__backend">
          <h3>BackEnd Developer</h3>

          <div className="experience__content">
          <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>NodeJS</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>MongoDB</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>MySQL</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>

          </div>
        </div>

        <div className="experience__graphics">
          <h3>Graphics Design</h3>

          <div className="experience__content">
          <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Adobe Photoshop</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Adobe Illustrator</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Canva</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__UI">
          <h3>UI/UX Design</h3>

          <div className="experience__content">
          <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Sketch</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Adobe XD</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className = 'experience__details-icon'/>
              <div>
              <h4>Figma</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience